import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Platform } from '@ionic/angular';
import { StatusBar } from '@capacitor/status-bar';
import videojs from 'video.js';

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrls: ['./video-player.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class VideoPlayerComponent implements OnInit, OnDestroy {
  @ViewChild('target', { static: true }) target: ElementRef;
  @Output() playerEnded = new EventEmitter<any>();
  @Output() playerPlayed = new EventEmitter<any>();
  @Output() taskFinished = new EventEmitter<any>(); // 影片剩餘10sec時 emit event
  taskFinishedEventEmittedFlag = false; // 是否已經發送 event

  @Input() taskFlag: boolean; // 是否為 執行任務的影片觀賞, if true, 將disable progress bar

  // _options: {
  //   fluid: boolean;
  //   aspectRatio: string;
  //   autoplay: boolean;
  //   sources: {
  //     src: string;
  //     type: string;
  //   }[];
  // };

  @Input() options: {
    fluid: boolean;
    aspectRatio: string;
    autoplay: boolean;
    sources: {
      src: string;
      type: string;
    }[];
  };

  player: videojs.Player;
  myPlayer;

  constructor(private elementRef: ElementRef, private platform: Platform) {}

  ngOnInit() {
    // this.player = videojs(
    //   this.target.nativeElement,
    //   this.options,
    //   function onPlayerReady() {
    //     console.log('onPlayerReady', this);
    //   }
    // );

    console.log('options', this.options);

    // APP 內已於原生層關閉 WKWebView 的 Element Fullscreen API（見 MainViewController.swift），
    // 避免 iOS 16.4+ 進全螢幕時出現「capacitor://localhost is in full screen」系統橫幅。
    // 這裡改用 video.js 的 full-window 模式取代原生播放器全螢幕，
    // 才能保留 video.js 控制列（任務影片鎖進度條的機制才不會被繞過）。
    // 純網頁版維持原行為（desktop 走 Fullscreen API、iPhone Safari 走原生播放器）。
    const playerOptions = {
      ...this.options,
      preferFullWindow: this.platform.is('capacitor'),
    };

    this.player = videojs(this.target.nativeElement, playerOptions, () => {
      console.log('onPlayerReady', this.player);
    });

    // full-window 模式進出時，同步隱藏/恢復 iOS 狀態列，模擬全螢幕體驗
    if (this.platform.is('capacitor')) {
      this.player.on('enterFullWindow', () => {
        StatusBar.hide().catch(() => {});
      });
      this.player.on('exitFullWindow', () => {
        StatusBar.show().catch(() => {});
      });
    }

    this.player.on('ended', () => {
      videojs.log('Awww...over so soon?!');
      console.log('player ended', this.player);
      this.playerEnded.emit(true);
      // const myVideo = videojs(this.target.nativeElement);
      // console.log('target', myVideo);

      // //如過要播放下一隻 video 可以從這裡加上 code
      // // eslint-disable-next-line max-len
      // this.player.src({
      //   type: 'video/mp4',
      //   // eslint-disable-next-line max-len
      //   src: 'https://storage.googleapis.com/mommycaretest.appspot.com/videos/2022-07-16/86 -Eighty Six- [ OP Full ]『Hitorie - 3 minutes 29 seconds _ 3分29秒』【Lyrics】-9c98.mp4',
      // });
      // this.player.play();
    });

    const onTimeUpdate = (event) => {
      // 影片的長度
      const duration = this.player.duration();
      console.log('player.duration()', duration);
      // 目前播放到的進度
      const currentTime = this.player.currentTime();
      console.log('player.currentTime()', currentTime);

      if (duration - currentTime <= 10) {
        if (this.taskFlag && this.taskFinishedEventEmittedFlag === false) {
          console.warn('影片剩餘不到10sec了, emit taskFinished event');
          this.taskFinishedEventEmittedFlag = true;
          this.taskFinished.emit(true);
        }
      }
    };

    this.player.on('play', () => {
      console.log('player play ', this.options.sources);
      setTimeout(() => {
        const duration = this.player.duration();
        console.log('duration', duration);
        this.playerPlayed.emit(duration);
      }, 1000);
    });

    this.player.on('timeupdate', onTimeUpdate);

    // 監聽 volumechange 事件, 以判斷是否靜音 or 開啟聲音
    this.player.on('volumechange', () => {
      console.log('volumechange this.player.muted()', this.player.muted());
      // 儲存目前聲音狀態到 localStorage
      localStorage.setItem('player_muted', this.player.muted());
    });

    // 下一行 如果是執行任務, 可以 disable 播放的progressControl
    console.warn('this.taskFlag', this.taskFlag);
    if (this.taskFlag) {
      this.player.controlBar.progressControl.disable();
    }
  }
  changeUrl(url) {
    console.log('changeUrl', url);
    this.taskFinishedEventEmittedFlag = false; // 換新影片, reset

    this.player.src({
      type: 'video/mp4',
      src: url,
    });
    this.player.play();
  }

  // @Input() set options(value: any) {
  //   if (value) {
  //     this._options = value;
  //     console.log('video _options', value);

  //     this.player = videojs(
  //       this.target.nativeElement,
  //       this.options,
  //       function onPlayerReady() {
  //         console.log('onPlayerReady', this);
  //       }
  //     );
  //   } else {
  //     this._options = null;
  //   }
  // }

  ngOnDestroy() {
    if (this.player) {
      // 若在 full-window 模式中直接離開頁面（如 Android 返回鍵），
      // 先退出 full-window，還原 body 的 vjs-full-window class 與 overflow 設定
      if (this.player.isFullscreen && this.player.isFullscreen()) {
        try {
          (this.player as any).exitFullWindow();
        } catch (e) {
          console.warn('exitFullWindow error', e);
        }
        if (this.platform.is('capacitor')) {
          StatusBar.show().catch(() => {});
        }
      }
      this.player.dispose();
    }
  }
}
